import React, { useEffect } from "react";
import { useState } from "react";
import StoryUnseen from "./img/story-unseen.svg?react";
import StoryUnseenMcLaren from "./img/story-unseen-mclaren.svg?react";
import StorySeen from "./img/story-seen.svg?react";
import StorySeenMcLaren from "./img/story-seen-mclaren.svg?react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "./style.scss";
import { filterUltraSpaceStories, getModuleValue } from "../../Helpers";
import ActivityPoints from "../ActivityPoints";
import { useQuery } from "@tanstack/react-query";
import {
  STORY_CACHE_TIME,
  STORY_STALE_TIME,
  getStoryList,
} from "../../api/story";
import {
  DETAILS_CACHE_TIME,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "../../api/consumer";
import NiceModal from "@ebay/nice-modal-react";
import storyBrithDatyRing from "./img/storyBrithDatyRing.png";
import brithDayImg from "./img/brithDayImg.png";
import DOMPurify from "dompurify";

export default function StoryTilesSwiper() {
  const [currentStoryAnimationIndex, setCurrentStoryAnimationIndex] = useState({
    index: -1,
    itemCount: -1,
  });

  const { data: stories, isLoading: isStoriesLoading } = useQuery({
    queryKey: ["story-list", "normal"],
    queryFn: () => getStoryList(),
    staleTime: STORY_STALE_TIME,
    cacheTime: STORY_CACHE_TIME,
  });

  const { data: details } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const ultraInsider = details?.consumer?.ultraInsider ?? false;
  const visibleStories = filterUltraSpaceStories(
    stories?.stories,
    ultraInsider
  );

  useEffect(() => {
    if (stories?.stories) {
      dataLayer.push({
        event: "view_stories_list",
        ...stories,
      });
    }
  }, []);

  useEffect(() => {
    if (visibleStories) {
      const count = visibleStories.reduce((acc, obj) => {
        if (obj.seen === false) {
          return acc + 1;
        }
        return acc;
      }, 0);

      if (
        count !== 0 &&
        count !== undefined &&
        count !== currentStoryAnimationIndex.itemCount
      ) {
        setCurrentStoryAnimationIndex({ index: 0, itemCount: count });
      }
    }
  }, [visibleStories]);

  useEffect(() => {
    if (
      currentStoryAnimationIndex.itemCount === -1 ||
      currentStoryAnimationIndex.itemCount === 0
    ) {
      return;
    }

    let interval;

    interval = setInterval(() => {
      setCurrentStoryAnimationIndex((prev) => ({
        ...prev,
        index: (prev.index + 1) % prev.itemCount,
      }));
    }, 4000);

    return () => clearInterval(interval);
  }, [currentStoryAnimationIndex.itemCount]);

  const [activeSkin, setActiveSkin] = useState(() => {
    const stored = localStorage.getItem("activeSkin");
    return stored || null;
  });

  useEffect(() => {
    const updateSkin = () => {
      const stored = localStorage.getItem("activeSkin");
      setActiveSkin(stored || null);
    };

    window.addEventListener("skinChange", updateSkin);
    return () => window.removeEventListener("skinChange", updateSkin);
  }, []);

  return (
    <div className="story-tiles-swiper-wrapper">
      <Swiper
        slidesPerView="auto"
        className="story-tiles-swiper"
        navigation={{
          nextEl: ".swiper-button-next.stories",
          prevEl: ".swiper-button-prev.stories",
        }}
        modules={[Navigation]}
        breakpoints={{
          0: {
            spaceBetween: 16,
          },
          1020: {
            spaceBetween: 24,
          },
          1590: {
            spaceBetween: 32,
          },
        }}
      >
        <>
          {/* <SwiperSlide key={"journey"}>
            <div
              className={`slide-wrapper`}
              onClick={() => {
                NiceModal.show("journey-modal");
              }}
            >
              <div
                className={`story-outline ${
                  currentStoryAnimationIndex.index ? "animate" : ""
                } brithDay `}
              >
                <img
                  className="storyBrithDatyRing"
                  alt="storyBrithDatyRing"
                  src={storyBrithDatyRing}
                />

                <img className="thumbnail" src={brithDayImg} alt="" />
              </div>
              <p>
                Inspiration <br />
                journey 2025
              </p>
            </div>
          </SwiperSlide> */}
          {visibleStories?.map((e, index) => (
            <SwiperSlide key={index}>
              <div
                className={`slide-wrapper ${e?.seen ? "disabled" : ""}`}
                onClick={() => {
                  dataLayer.push({
                    event: "select_stories",
                    stories: e,
                  });

                  NiceModal.show("story-wrapper-modal", {
                    initialStoryUUID: e.uuid,
                  });
                }}
              >
                <div
                  className={`story-outline ${index === currentStoryAnimationIndex.index ? "animate" : ""
                    }`}
                >
                  {e.seen ? (activeSkin === "mclaren2025" ? <StorySeenMcLaren /> : <StorySeen />) : (activeSkin === "mclaren2025" ? <StoryUnseenMcLaren/> : <StoryUnseen />)}
                  <img
                    src={getModuleValue(
                      e?.content?.modules,
                      "thumbnail",
                      "file.url"
                    )}
                    alt={getModuleValue(
                      e?.content?.modules,
                      "thumbnail",
                      "metadata.imgDesc"
                    )}
                  />
                </div>
                {e?.award?.available && (
                  <ActivityPoints>{e?.award?.points}</ActivityPoints>
                )}
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(e?.content?.title)}} />
              </div>
            </SwiperSlide>
          ))}
        </>
      </Swiper>
    </div>
  );
}
